import { Countries } from '@platform/client';
import { MultiSelectDropdown } from '@platform/components';
import { UseFormRegisterReturn } from 'react-hook-form';

type MultipleCountrySelectionDropdownProps = {
  selectionLimit?: number;
  selectedCountries: string[];
  onCountriesSelectionChange: (selectedCountries: string[]) => void;
  register?: () => UseFormRegisterReturn<string>;
  errors?: Record<string, { message: string } | undefined>;
  placeholder?: string;
  label: string;
};
export const MultipleCountrySelectionDropdown = (props: MultipleCountrySelectionDropdownProps) => {
  const {
    selectionLimit,
    selectedCountries,
    onCountriesSelectionChange,
    register,
    errors,
    placeholder,
    label,
  } = props;

  const countriesList = Countries.useGetCountries();

  const countryOptions =
    countriesList.isSuccess ?
      countriesList.data.map((country) => ({
        label: country.name,
        value: country.id,
      }))
    : [];

  return (
    <div className='w-[350px]'>
      <MultiSelectDropdown
        register={register}
        selectedItems={selectedCountries}
        onSelectionChange={onCountriesSelectionChange}
        options={countryOptions}
        selectionLimit={selectionLimit}
        label={label}
        error={errors?.countries?.message}
        filterable={true}
        placeholder={placeholder || 'Select countries'}
      />
    </div>
  );
};
